export default __webpack_public_path__ + "static/Ramme-c3ef233590ddaebd0693102d67b77d86.svg";